import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';

import { sharedClasses } from './sharedClasses';

const InfoBox = ({ message }: { message: string | React.JSX.Element }) => (
  <Box sx={sharedClasses.noticeContainer}>
    <Box sx={{ display: 'flex' }}>
      <InfoIcon sx={sharedClasses.noticeIcon} />
      {message}
    </Box>
  </Box>
);

export default InfoBox;
